export const generalData_Types = {
  SET_ONLINE_USERS: "SET_ONLINE_USERS",
  ADD_ONLINE_USER: "ADD_ONLINE_USER",
  REMOVE_ONLINE_USER: "REMOVE_ONLINE_USER",
  SET_ONLINE_USERS_BADGE: "SET_ONLINE_USERS_BADGE",
  SET_SHOW_NOTIF_POPUP_DISPLAY: "SET_SHOW_NOTIF_POPUP_DISPLAY",
  SET_NOTIFICATIONS: "SET_NOTIFICATIONS",
  SET_FETCH_ONLINE_USERS_LOADING_STATUS:
    "SET_FETCH_ONLINE_USERS_LOADING_STATUS",
  RESET_STORE_STATE: "RESET_STORE_STATE",
};
